// extracted by mini-css-extract-plugin
module.exports = {"no-image":"b1ddd01198--no-image--rLJjF","no-image-icon":"b1ddd01198--no-image-icon--ERA5X"};